import React from 'react';
import Spinner from "../Spinner/Spinner";
import './Loader.styles.scss';

function Loader({ isActive }) {
    return (
        <div className={`loader ${isActive ? 'loader--visible' : ''}`}>
            <Spinner/>
        </div>
    );
}

export default Loader;